/**
 * AdminShell -- Lazy wrapper for the admin dashboard embedded in the main client.
 *
 * Gates on sessionState.canAccessAdmin. Composes AdminContext from the main
 * client's existing auth and flow infrastructure, then renders AdminApp.
 *
 * The entire admin bundle is code-split via React.lazy, so none of the
 * @elara/admin code loads until a privileged user navigates to /admin/*.
 */
import { lazy,Suspense } from 'react';

import { useAppStates } from '#states/hooks.js';

const LazyAdminEmbed = lazy(async () => import('./AdminEmbed.jsx'));

export function AdminShell() {
  const { sessionState } = useAppStates('sessionState');

  if (sessionState.isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!sessionState.canAccessAdmin) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-center">
          <h1 className="font-display text-lg font-semibold text-foreground">Access Denied</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Admin dashboard requires admin access.
          </p>
        </div>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center">
          <p className="text-sm text-muted-foreground">Loading admin...</p>
        </div>
      }
    >
      <LazyAdminEmbed />
    </Suspense>
  );
}
